/**
 * Created by Vasilenko on 17-Nov-16.
 */
export var GameState;
(function (GameState) {
    GameState[GameState["None"] = 0] = "None";
    GameState[GameState["Won"] = 1] = "Won";
    GameState[GameState["GameOver"] = 2] = "GameOver";
})(GameState || (GameState = {}));
//# sourceMappingURL=game-state.enum.js.map